import { render, staticRenderFns } from "./EducationPostCard.vue?vue&type=template&id=c17b40f6&scoped=true&"
import script from "./EducationPostCard.vue?vue&type=script&lang=js&"
export * from "./EducationPostCard.vue?vue&type=script&lang=js&"
import style0 from "./EducationPostCard.vue?vue&type=style&index=0&id=c17b40f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17b40f6",
  null
  
)

export default component.exports